import api, { checkTokenErrorResponse } from '..';


export async function getCollaborators() {
    return api.get("colaboradores/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postCollaborator(
    nome,
    data_admissao,
    inativo,
    data_demissao,
    documento,
    telefone,
    ddi,
    iso2_ddi,
    logradouro,
    cidade,
    bairro,
    estado,
    cep,
    foto,
    observacao,
    salario,
    cargo,
    ferias
) {
    const formdata = new FormData();

    formdata.append("nome", nome);
    formdata.append("documento", documento);
    formdata.append("data_admissao", data_admissao);
    formdata.append("inativo", inativo ? "true": "false");
    if(inativo)
        formdata.append("data_demissao", data_demissao);
    else
        formdata.append("data_demissao", "");

    if(telefone)
        formdata.append("telefone", telefone);
    if(ddi)
        formdata.append("ddi", ddi);
    if(iso2_ddi)
        formdata.append("iso2_ddi", iso2_ddi);
    formdata.append("logradouro", logradouro);
    formdata.append("bairro", bairro);
    formdata.append("estado", estado);
    formdata.append("cidade", cidade);
    formdata.append("cep", cep);

    if(foto && foto instanceof File)
        formdata.append("foto", foto);

    formdata.append("observacao", observacao);
    formdata.append("salario", salario);
    formdata.append("cargo", cargo);
    formdata.append("ferias", ferias);

    return api.post(`colaboradores/`, formdata, {
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function getCollaborator(id) {
    return api.get(`colaboradores/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function deleteCollaborator(id) {
    return api.delete(`colaboradores/${id}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};


export async function patchCollaborator(
    id,
    nome,
    data_admissao,
    inativo,
    data_demissao,
    documento,
    telefone,
    ddi,
    iso2_ddi,
    logradouro,
    cidade,
    bairro,
    estado,
    cep,
    foto,
    observacao,
    salario,
    cargo,
    ferias
) {
    const formdata = new FormData();

    formdata.append("nome", nome);
    formdata.append("documento", documento);
    formdata.append("data_admissao", data_admissao);
    formdata.append("inativo", inativo ? "true": "false");
    if(inativo)
        formdata.append("data_demissao", data_demissao);
    else
        formdata.append("data_demissao", "");


    if(telefone)
        formdata.append("telefone", telefone);
    if(ddi)
        formdata.append("ddi", ddi);
    if(iso2_ddi)
        formdata.append("iso2_ddi", iso2_ddi);
    formdata.append("logradouro", logradouro);
    formdata.append("bairro", bairro);
    formdata.append("estado", estado);
    formdata.append("cidade", cidade);
    formdata.append("cep", cep);

    if(foto && foto instanceof File)
        formdata.append("foto", foto);


    formdata.append("observacao", observacao);
    formdata.append("salario", salario);
    formdata.append("cargo", cargo);
    formdata.append("ferias", ferias);
    

    return api.patch(`colaboradores/${id}/`, formdata)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
};

export async function postLinkCollaboratorCompany(collaboratorId, companyId) {
    return api.post(`colaboradores/${collaboratorId}/vincular_empresa/${companyId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function postLinkCollaboratorCompanys(collaboratorId, companyIds) {
    return api.post(`colaboradores/${collaboratorId}/vincular_empresas/`, {
        ids: companyIds
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function deleteLinkCollaboratorCompany(collaboratorId, companyId) {
    return api.delete(`colaboradores/${collaboratorId}/desvincular_empresa/${companyId}/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function postPayment(id, data, data_referente, valor_pago) {
    return api.post(`colaboradores/${id}/pagamentos/`, {
        data,
        data_referente,
        valor_pago
    })
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function getPayments(id) {
    return api.get(`colaboradores/${id}/pagamentos/`)
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}




const collaboratorServices = {
    getCollaborators,
    getCollaborator,
    postCollaborator,
    deleteCollaborator,
    patchCollaborator,
    postLinkCollaboratorCompany,
    postLinkCollaboratorCompanys,
    deleteLinkCollaboratorCompany,
    postPayment,
    getPayments
}
export default collaboratorServices;